import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { atom, useRecoilState, useRecoilValue } from "recoil";
import styled from "styled-components";
import { GetSubscriptionSetData } from "../../../../../Api/ServiceDatas";
import {
  GetAllSubscriptionSetDataByServID,
  GetServiceSetData,
  GetServiceSetDataNoHide,
  getAllSvcData,
} from "../../../../../ApiTS/ServiceDatasTS";
import Flex from "../../../../DefaultStyles/Flex";
import DropDown, { OptionType } from "../../../../Filters/DropDown";
import { sunsetDetailButtonType } from "../SunsetDetailButtons";
import { ISunsetData } from "./SunsetDetailInfo";
import { getSubsNameBySubsId3 } from "../../../../../AdminApi/3.0_utils";

export const sunsetDetailDataState = atom({
  key: "sunsetDetailDataState",
  default: {
    sunsetSubsId: 0,
    sunriseSubsId: 0,
    sunsetParty: "",
    sunsetType: 0,
    notifyType: 0,
    sunsetDate: "",
    sunriseDate: "",
    notifyDate: "",
    sunsetReason: "",
  },
});

export default function SunsetSubs() {
  const location = useLocation() as unknown as ISunsetData;
  const buttonType = useRecoilValue(sunsetDetailButtonType);

  const [sunsetDetailData, setSunsetDetailData] = useRecoilState(
    sunsetDetailDataState
  );

  const sunsetData = location?.state?.sunsetData;
  const sunsetServData = GetServiceSetData(sunsetData?.ssetSubs);

  const [allServList, setAllServList] = useState([
    // 일몰 대상 서비스 리스트
    { value: "", label: "선택" },
  ]);
  const [allSubsList, setAllSubsList] = useState([
    // 일몰 대상 subscription 리스트
    { value: "", label: "선택" },
  ]);

  const [sunsetServId, setSunsetServId] = useState({
    // 일몰 대상 서비스
    value: location?.state ? `${sunsetServData?.SVC_ID}` : "",
    label: location?.state
      ? `${sunsetServData?.SVC_ID}_${sunsetServData?.SVC_NMKR_TEMP}`
      : "서비스 선택",
  });
  const [sunsetSubsId, setSunsetSubsId] = useState<OptionType>({
    // 일몰 대상 subscription
    value: location?.state ? `${sunsetData?.ssetSubs}` : "",
    label: location?.state
      ? `${sunsetData?.ssetSubs}_${getSubsNameBySubsId3(sunsetData?.ssetSubs)}`
      : "subscription 선택",
  });

  useEffect(() => {
    // serv 선택 옵션
    const servOptionList = [];

    const activeServs = getAllSvcData();

    for (let i = 0; i < activeServs?.length; i++) {
      const e = activeServs[i];

      servOptionList.push({
        label: `${e?.SVC_ID}_${e?.SVC_NMKR_TEMP}`,
        value: `${e?.SVC_ID}`,
      });
    }

    setAllServList(servOptionList);
  }, []);

  useEffect(() => {
    // subscription 선택 옵션
    const subsBySvcId = GetAllSubscriptionSetDataByServID(
      Number(sunsetServId?.value)
    );
    const subsOptionList = [];

    for (let i = 0; i < subsBySvcId.length; i++) {
      const e = subsBySvcId[i];

      subsOptionList.push({
        label: `${e?.SUBS_ID}_${getSubsNameBySubsId3(e?.SUBS_ID)}`,
        value: `${e?.SUBS_ID}`,
      });
    }

    setAllSubsList(subsOptionList);
  }, [sunsetServId?.value]);

  useEffect(() => {
    if (location?.state) {
      const sunsetSubsData = GetSubscriptionSetData(sunsetData?.ssetSubs)[0];
      const sunsetServData = GetServiceSetData(sunsetSubsData?.SVC_ID ?? 0);

      setSunsetServId({
        value: `${sunsetSubsData?.SVC_ID}`,
        label: `${sunsetServData?.SVC_ID}_${
          sunsetServData?.SVC_NMKR_TEMP ?? ""
        }`,
      });

      setSunsetSubsId({
        value: `${sunsetData?.ssetSubs}`,
        label: `${sunsetData?.ssetSubs}_${getSubsNameBySubsId3(
          sunsetData?.ssetSubs
        )}`,
      });
    } else {
      setSunsetServId({
        value: "",
        label: "서비스 선택",
      });
      setSunsetSubsId({
        value: "",
        label: "subscription 선택",
      });
    }
  }, [location?.state]);

  useEffect(() => {
    if (sunsetSubsId?.value !== "") {
      setSunsetDetailData({
        ...sunsetDetailData,
        sunsetSubsId: +sunsetSubsId?.value!,
      });
    }
  }, [sunsetSubsId]);

  return (
    <VerticalTableRow>
      <VerticalTableLabel>일몰 대상 서비스</VerticalTableLabel>

      <Flex gapSize={10}>
        {/* 일몰 대상 서비스 선택 */}
        {buttonType === "view" ? (
          <VerticalTableValue style={{ width: 120 }}>
            {sunsetServId?.label}
          </VerticalTableValue>
        ) : (
          <DropDown
            dropdownValue={sunsetServId}
            setDropDownValue={setSunsetServId}
            optionList={allServList}
            boxWidth={120}
          />
        )}

        {/* 일몰 대상 subs 선택 */}
        {buttonType === "view" ? (
          <VerticalTableValue style={{ width: 180 }}>
            {sunsetSubsId?.label}
          </VerticalTableValue>
        ) : (
          <DropDown
            dropdownValue={sunsetSubsId}
            setDropDownValue={setSunsetSubsId}
            optionList={allSubsList}
            boxWidth={180}
            isDisabled={sunsetServId?.value === ""}
          />
        )}
      </Flex>
    </VerticalTableRow>
  );
}

export const VerticalTableRow = styled.div`
  width: 100%;
  display: flex;
  align-items: center;

  &:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.buttonColor.lineNormal};
  }
`;

export const VerticalTableLabel = styled.div`
  width: 148px;
  padding: 20px 10px;

  font-size: 15px;
  font-weight: bold;
  line-height: 22.5px;
  text-align: left;
  color: #858c97;
  word-break: keep-all;
`;

export const VerticalTableValue = styled.div`
  width: 220px;
  height: 38px;
  border-radius: 3px;
  background-color: #f6f6f8;
  padding: 0 16px;
  display: flex;
  align-items: center;

  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  text-align: left;
  color: ${({ theme }) => theme.color.gray500};
`;
